[
  {
    "code": "UTC",
    "label": {
      "en": "(UTC+00:00) UTC",
      "es": "(UTC+00:00) UTC"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "offset": "+00:00"
    }
  },
  {
    "code": "Europe/Madrid",
    "label": {
      "en": "(UTC+01:00) Madrid",
      "es": "(UTC+01:00) Madrid"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/London",
    "label": {
      "en": "(UTC+00:00) London",
      "es": "(UTC+00:00) Londres"
    },
    "order": 3,
    "is_active": true,
    "metadata": {
      "offset": "+00:00"
    }
  },
  {
    "code": "Europe/Paris",
    "label": {
      "en": "(UTC+01:00) Paris",
      "es": "(UTC+01:00) París"
    },
    "order": 4,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Berlin",
    "label": {
      "en": "(UTC+01:00) Berlin",
      "es": "(UTC+01:00) Berlín"
    },
    "order": 5,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Rome",
    "label": {
      "en": "(UTC+01:00) Rome",
      "es": "(UTC+01:00) Roma"
    },
    "order": 6,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Lisbon",
    "label": {
      "en": "(UTC+00:00) Lisbon",
      "es": "(UTC+00:00) Lisboa"
    },
    "order": 7,
    "is_active": true,
    "metadata": {
      "offset": "+00:00"
    }
  },
  {
    "code": "Europe/Amsterdam",
    "label": {
      "en": "(UTC+01:00) Amsterdam",
      "es": "(UTC+01:00) Ámsterdam"
    },
    "order": 8,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Brussels",
    "label": {
      "en": "(UTC+01:00) Brussels",
      "es": "(UTC+01:00) Bruselas"
    },
    "order": 9,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Zurich",
    "label": {
      "en": "(UTC+01:00) Zurich",
      "es": "(UTC+01:00) Zúrich"
    },
    "order": 10,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Vienna",
    "label": {
      "en": "(UTC+01:00) Vienna",
      "es": "(UTC+01:00) Viena"
    },
    "order": 11,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Warsaw",
    "label": {
      "en": "(UTC+01:00) Warsaw",
      "es": "(UTC+01:00) Varsovia"
    },
    "order": 12,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Prague",
    "label": {
      "en": "(UTC+01:00) Prague",
      "es": "(UTC+01:00) Praga"
    },
    "order": 13,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Stockholm",
    "label": {
      "en": "(UTC+01:00) Stockholm",
      "es": "(UTC+01:00) Estocolmo"
    },
    "order": 14,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Oslo",
    "label": {
      "en": "(UTC+01:00) Oslo",
      "es": "(UTC+01:00) Oslo"
    },
    "order": 15,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Copenhagen",
    "label": {
      "en": "(UTC+01:00) Copenhagen",
      "es": "(UTC+01:00) Copenhague"
    },
    "order": 16,
    "is_active": true,
    "metadata": {
      "offset": "+01:00"
    }
  },
  {
    "code": "Europe/Helsinki",
    "label": {
      "en": "(UTC+02:00) Helsinki",
      "es": "(UTC+02:00) Helsinki"
    },
    "order": 17,
    "is_active": true,
    "metadata": {
      "offset": "+02:00"
    }
  },
  {
    "code": "Europe/Athens",
    "label": {
      "en": "(UTC+02:00) Athens",
      "es": "(UTC+02:00) Atenas"
    },
    "order": 18,
    "is_active": true,
    "metadata": {
      "offset": "+02:00"
    }
  },
  {
    "code": "Europe/Moscow",
    "label": {
      "en": "(UTC+03:00) Moscow",
      "es": "(UTC+03:00) Moscú"
    },
    "order": 19,
    "is_active": true,
    "metadata": {
      "offset": "+03:00"
    }
  },
  {
    "code": "America/New_York",
    "label": {
      "en": "(UTC-05:00) New York",
      "es": "(UTC-05:00) Nueva York"
    },
    "order": 20,
    "is_active": true,
    "metadata": {
      "offset": "-05:00"
    }
  },
  {
    "code": "America/Chicago",
    "label": {
      "en": "(UTC-06:00) Chicago",
      "es": "(UTC-06:00) Chicago"
    },
    "order": 21,
    "is_active": true,
    "metadata": {
      "offset": "-06:00"
    }
  },
  {
    "code": "America/Denver",
    "label": {
      "en": "(UTC-07:00) Denver",
      "es": "(UTC-07:00) Denver"
    },
    "order": 22,
    "is_active": true,
    "metadata": {
      "offset": "-07:00"
    }
  },
  {
    "code": "America/Los_Angeles",
    "label": {
      "en": "(UTC-08:00) Los Angeles",
      "es": "(UTC-08:00) Los Ángeles"
    },
    "order": 23,
    "is_active": true,
    "metadata": {
      "offset": "-08:00"
    }
  },
  {
    "code": "America/Toronto",
    "label": {
      "en": "(UTC-05:00) Toronto",
      "es": "(UTC-05:00) Toronto"
    },
    "order": 24,
    "is_active": true,
    "metadata": {
      "offset": "-05:00"
    }
  },
  {
    "code": "America/Mexico_City",
    "label": {
      "en": "(UTC-06:00) Mexico City",
      "es": "(UTC-06:00) Ciudad de México"
    },
    "order": 25,
    "is_active": true,
    "metadata": {
      "offset": "-06:00"
    }
  },
  {
    "code": "America/Buenos_Aires",
    "label": {
      "en": "(UTC-03:00) Buenos Aires",
      "es": "(UTC-03:00) Buenos Aires"
    },
    "order": 26,
    "is_active": true,
    "metadata": {
      "offset": "-03:00"
    }
  },
  {
    "code": "America/Sao_Paulo",
    "label": {
      "en": "(UTC-03:00) São Paulo",
      "es": "(UTC-03:00) São Paulo"
    },
    "order": 27,
    "is_active": true,
    "metadata": {
      "offset": "-03:00"
    }
  },
  {
    "code": "America/Bogota",
    "label": {
      "en": "(UTC-05:00) Bogotá",
      "es": "(UTC-05:00) Bogotá"
    },
    "order": 28,
    "is_active": true,
    "metadata": {
      "offset": "-05:00"
    }
  },
  {
    "code": "America/Lima",
    "label": {
      "en": "(UTC-05:00) Lima",
      "es": "(UTC-05:00) Lima"
    },
    "order": 29,
    "is_active": true,
    "metadata": {
      "offset": "-05:00"
    }
  },
  {
    "code": "America/Santiago",
    "label": {
      "en": "(UTC-04:00) Santiago",
      "es": "(UTC-04:00) Santiago"
    },
    "order": 30,
    "is_active": true,
    "metadata": {
      "offset": "-04:00"
    }
  },
  {
    "code": "America/Caracas",
    "label": {
      "en": "(UTC-04:00) Caracas",
      "es": "(UTC-04:00) Caracas"
    },
    "order": 31,
    "is_active": true,
    "metadata": {
      "offset": "-04:00"
    }
  },
  {
    "code": "Asia/Tokyo",
    "label": {
      "en": "(UTC+09:00) Tokyo",
      "es": "(UTC+09:00) Tokio"
    },
    "order": 32,
    "is_active": true,
    "metadata": {
      "offset": "+09:00"
    }
  },
  {
    "code": "Asia/Shanghai",
    "label": {
      "en": "(UTC+08:00) Shanghai",
      "es": "(UTC+08:00) Shanghái"
    },
    "order": 33,
    "is_active": true,
    "metadata": {
      "offset": "+08:00"
    }
  },
  {
    "code": "Asia/Hong_Kong",
    "label": {
      "en": "(UTC+08:00) Hong Kong",
      "es": "(UTC+08:00) Hong Kong"
    },
    "order": 34,
    "is_active": true,
    "metadata": {
      "offset": "+08:00"
    }
  },
  {
    "code": "Asia/Singapore",
    "label": {
      "en": "(UTC+08:00) Singapore",
      "es": "(UTC+08:00) Singapur"
    },
    "order": 35,
    "is_active": true,
    "metadata": {
      "offset": "+08:00"
    }
  },
  {
    "code": "Asia/Seoul",
    "label": {
      "en": "(UTC+09:00) Seoul",
      "es": "(UTC+09:00) Seúl"
    },
    "order": 36,
    "is_active": true,
    "metadata": {
      "offset": "+09:00"
    }
  },
  {
    "code": "Asia/Dubai",
    "label": {
      "en": "(UTC+04:00) Dubai",
      "es": "(UTC+04:00) Dubái"
    },
    "order": 37,
    "is_active": true,
    "metadata": {
      "offset": "+04:00"
    }
  },
  {
    "code": "Asia/Kolkata",
    "label": {
      "en": "(UTC+05:30) Kolkata",
      "es": "(UTC+05:30) Calcuta"
    },
    "order": 38,
    "is_active": true,
    "metadata": {
      "offset": "+05:30"
    }
  },
  {
    "code": "Australia/Sydney",
    "label": {
      "en": "(UTC+11:00) Sydney",
      "es": "(UTC+11:00) Sídney"
    },
    "order": 39,
    "is_active": true,
    "metadata": {
      "offset": "+11:00"
    }
  },
  {
    "code": "Pacific/Auckland",
    "label": {
      "en": "(UTC+13:00) Auckland",
      "es": "(UTC+13:00) Auckland"
    },
    "order": 40,
    "is_active": true,
    "metadata": {
      "offset": "+13:00"
    }
  },
  {
    "code": "Atlantic/Canary",
    "label": {
      "en": "(UTC+00:00) Canary Islands",
      "es": "(UTC+00:00) Islas Canarias"
    },
    "order": 41,
    "is_active": true,
    "metadata": {
      "offset": "+00:00"
    }
  }
]
